<template lang="html">
    <div class="main">
        <!-- <img src="../asssts/download/download_bg1.png" alt=""> -->
        <!-- <img class="download-title" src="../assets/download/down_load_title.png" alt=""> -->
        <h1 class="downloaarticle-main-title">Selamat!</h1>
        <p class="download-article">
            Anda telah mengunduh Aplikasi All Football, yang merupakan versi terbaru dari situs web ini dan akan memberikan pengalaman penggunaan yang lebih baik.
        </p>
        <p class="download-article">
            <b class="download-article-bold">Berikut adalah beberapa petunjuk tentang cara menginstal aplikasi kami.</b>
        </p>
        <h2 class="downloaarticle-title">1. Unduh aplikasi</h2>
        <p class="download-article" v-if="!is_opreamini">
            Jika Anda secara tidak sengaja membatalkan unduhan, Anda dapat klik tautan di bawah ini untuk mengunduh kembali.
        </p>
        <img @click="jumpUrl" class="download-btn" src="../assets/download/download_btn.png" />
        <p class="download-article">
            Jika muncul peringatan biasa tentang kemungkinan kerusakan perangkat, konfirmasi <b class="green">"OK"</b> - Kami menjamin bahwa aplikasi kami pasti tidak akan merusak perangkat Anda.
        </p>
        <img src="../assets/download/download_pic1.png" alt="">
        <h2 class="downloaarticle-title">2. Atur pengaturan telepon</h2>
        <p class="download-article">
            Anda akan menemukan aplikasi yang diunduh di <b class="green">"Notifikasi"</b> atau di <b
            class="green">"Unduhan"</b> folder. Klik pada itu, pilih <b class="green">"Instal"</b> dan konfirmasi.
        </p>
        <img src="../assets/download/download_pic2.png" alt="">
        <h2 class="downloaarticle-title">3. Tidak berhasil</h2>
        <p class="download-article">
            Anda akan menemukan aplikasi yang diunduh di <b class="green">"Notifikasi"</b> atau di <b
            class="green">"Unduhan"</b> folder. Klik pada itu, pilih <b class="green">"Instal"</b> dan konfirmasi.
        </p>
        <img src="../assets/download/download_pic3.png" alt="">
        <div class="download-bottom">
            <h2 class="downloaarticle-title">Tidak berhasil?</h2>
            <p class="download-article">
                Coba lagi mengikuti petunjuk di atas. Atau unduh versi aplikasi terbaru dari <a
                href="https://at.umeng.com/SbK5Lf"><b class="green">Google_Play</b></a>.
            </p>
        </div>
    </div>
</template>

<script>
import { record, getQueryString } from '../util/util';

export default {
    data () {
        return {
            is_opreamini: false
        };
    },
    mounted () {
        record(`msite/download?from=${getQueryString('from')}`);
        ga('send', 'event', 'downloadPage', 'enter', getQueryString('from'));
        let utilObj = require('@/util/util.js');
        if (!utilObj.checkOperamini()) {
            this.jumpUrl();
        }
        this.is_opreamini = utilObj.checkOperamini();
    },
    methods: {
        jumpUrl: function () {
            let utilObj = require('@/util/util.js');
            utilObj.jumpUrl(true);
        }
    }
};
</script>

<style lang="css" scoped>
    .main {
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    }

    img {
        display: block;
        margin: 0;
    }

    .downloaarticle-main-title {
        padding-bottom: 22px;
        margin-top: 25px;
        color: #16ac3a;
        font-size: 31px;
        font-weight: 800;
        text-align: center;
    }

    .download-article-bold {
        display: inline-block;
        width: 270px;
        margin-bottom: 17px;
    }

    .download-title {
        width: 175px;
        margin: 0 auto;
        margin-top: 10px;
    }

    .downloaarticle-title {
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
        padding: 22px 0;
        color: #16ac3a;
        font-size: 24px;
        font-weight: 800;
        text-align: center;
    }

    .downloaarticle-title:first-of-type {
        border-top: 1px solid #f4f6f8;
    }

    .download-btn {
        width: 150px;
        height: 45px;
        margin: 0 auto;
        margin-bottom: 20px;
        margin-top: 10px;
    }

    .download-article {
        padding: 0 10px 10px;
        color: #2d2f32;
        font-size: 16px;
        text-align: center;
    }

    .download-article:first-of-type {
        padding: 0 10px 26px 10px;

    }

    .download-article .green {
        color: #16ac3a;
    }

    .download-bottom {
        background: #eff1f4;
        margin-top: -1px;
    }
</style>



// WEBPACK FOOTER //
// AppDownload.vue?60d9d27f